import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import IconsOrTagline from "../IconsOrTagline";
import SelectBox from "../SelectBox";
import { useAlgoliaProductSearch } from "../../services/algoliaService";
import { Flags } from "../Flags";
import "./style.scss";

const ProductSelectItem = ({ item }) => {
  const { name, tagline, images, specsIndexed, sku } = item;

  return (
    <>
      <div className={"image-col"}>
        <div className="image-container">
          <div
            className="productPreviewImage"
            style={{
              backgroundImage: `url("${images[0].styles.preview}")`
            }}
          ></div>
        </div>
      </div>
      <div className={"info-col"}>
        <h4>
          <span className="text-pale">{sku} </span>
          <span>{name}</span>
          <Flags product={item} inline={true} />
        </h4>
        <div className="specs">
          <IconsOrTagline
            specsIndexed={specsIndexed}
            showLabel={false}
            sku={sku}
            tagline={tagline}
            noTooltips
          />
        </div>
      </div>
    </>
  );
};

const ProductSelectedValueDisplay = ({ item }) => {
  const firstImage = item?.images?.[0].styles?.preview;
  return (
    <>
      <div
        className="selected-value-display-image"
        style={{
          backgroundImage: firstImage && `url("${firstImage}")`
        }}
      ></div>
      <div className="selected-value-display-text">
        <span className="text-pale">{item.sku}</span>
        <span className={"ms-2"}>{item.name}</span>
        <Flags product={item} inline={true} />
      </div>
    </>
  );
};

function useProductSearch(query, limit = 8) {
  const { products: searchResult = [] } = useAlgoliaProductSearch(query, limit);
  return searchResult;
}

const ProductSelect = ({
  initialValue,
  onChange = _item => {},
  allowCustomInput = false,
  id = "",
  className = "product-select",
  itemClassName = "product-select-item",
  style = {}
}) => {
  const t = useBjelinTranslations();
  return (
    <SelectBox
      ItemComponent={ProductSelectItem}
      SelectedValueDisplay={ProductSelectedValueDisplay}
      itemIdField="sku"
      itemTitleField="name"
      searchHook={useProductSearch}
      initialValue={initialValue}
      onChange={onChange}
      placeholder={t("search.field-label")}
      hintText={t("search.hint")}
      noMatchText={t("search.b2b.no-match")}
      allowCustomInput={allowCustomInput}
      id={id}
      className={className}
      itemClassName={itemClassName}
      style={style}
    />
  );
};

export default ProductSelect;
